/**
 * Created by richardlovejoy on 3/7/17.
 */
import _ from 'underscore';

// TODO - make this use 'TurnGenerator'

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const DummyTurnService = {

  SECURITY_EXCEPTION_TURN_TOO_FAST: 1,
  SECURITY_EXCEPTION_BALL_MISMATCH: 2,
  SECURITY_EXCEPTION_BONUS_MISMATCH: 3,
  SECURITY_EXCEPTION_SCORE_MISMATCH: 4,
  SECURITY_EXCEPTION_BAD_CUP_ID: 5,

  onSignalBallDataReceived: new Phaser.Signal(),
  onSignalLeaderDataReceived: new Phaser.Signal(),
  onSignalInitialsSubmitted: new Phaser.Signal(),
  onSignalRankDataReceived: new Phaser.Signal(),
  onSignalEndGameReceived: new Phaser.Signal(),

  // dummy server
  gameData: null,

  // start game - retrieve initial set of balls
  startGame_dumb(simple) {

    // generate balls and token
    // (using php naming convention for variables)
    var cup_ids = this.generateCupIDs();
    var data = (simple) ? {
        gamesPlayed_id: 1
      } : {
        token: this.generateGameToken(0),
        balls: this.generateBalls(10),
        ids: cup_ids,
        scr: this.cupIDScramble(),
        bonus_cup: this.generateBonusCup(cup_ids),
        score: 0
      };

    // save stuff
    this.gameData = data;

    setTimeout(() => {

      this.onSignalBallDataReceived.dispatch(data);

    }, 200);

    return this.onSignalBallDataReceived;
  },

  endGame_dumb(simple) {

    setTimeout(() => {

      this.onSignalEndGameReceived.dispatch({
        exc: 0
      });

    }, 200);

    return this.onSignalEndGameReceived;
  },

  endTurn_dumb(gameRecord_id, ballAttributes, cupId, score, extraBall) {

    const currentBall = this.gameData.balls.shift();

    if (ballAttributes.multiplier !== currentBall.multiplier)
    {
      //console.log('exception', ballAttributes.multiplier, currentBall.multiplier);
      this.securityException(this.SECURITY_EXCEPTION_BONUS_MISMATCH);
    }

    // update score
    const cupScrambles = [
      [2, 4, 1, 6, 3, 0, 5],
      [3, 5, 2, 0, 4, 6, 1],
      [4, 2, 3, 0, 1, 6, 5],
      [0, 3, 2, 6, 4, 5, 1],
      [5, 1, 6, 3, 4, 2, 0],
      [5, 4, 2, 1, 0, 6, 3],
      [0, 3, 1, 2, 6, 4, 5],
      [1, 4, 2, 0, 6, 5, 3],
      [4, 2, 1, 5, 0, 3, 6],
      [1, 5, 3, 4, 6, 0, 2]
    ];
    const cupScramble = cupScrambles[this.gameData.scr];

    let previousScore = this.gameData.score;
    let newScore = 0;
    const points = [10, 20, 30, 40, 50, 100, 100];
    const key = this.gameData.ids.indexOf(cupId);
    if (key < 0) {
      // bad cup id
      this.securityException(this.SECURITY_EXCEPTION_BALL_MISMATCH);
    }
    else {

      // accumulate score w/ multiplier
      newScore = previousScore + points[cupScramble[key]] * currentBall.multiplier;

      // check score
      if (score !== newScore)
      {
        this.securityException(this.SECURITY_EXCEPTION_SCORE_MISMATCH);
      }
      // save new score
      this.gameData.score = newScore;

    }

    // check if they won an extra ball (by hitting lit up cup)
    let newBalls = [];
    //console.log('-->', cupId, this.gameData.bonus_cup);
    if (this.gameData.bonus_cup !== 0 && cupId == this.gameData.bonus_cup) {

      // award extra ball
      newBalls = this.generateBalls(1);
    }

    // if score passed 600, add 3 extra balls
    if (newScore >= 600 && previousScore < 600)
    {
      newBalls = newBalls.concat(this.generateBalls(3));
    }

    this.gameData.balls = this.gameData.balls.concat(newBalls);

    // if game is over, update with final score
    const responseData = {
      endgame: true,
      score: newScore
    };
    if (this.gameData.balls.length > 0)
    {

      // send new balls and cup id's
      let cup_ids = this.generateCupIDs();
      responseData.balls = newBalls;
      responseData.ids = cup_ids;
      responseData.scr = this.cupIDScramble();
      responseData.bonus_cup = this.generateBonusCup(cup_ids);
      responseData.endgame = false;

      // update other session vars
      this.gameData.ids = cup_ids;
      this.gameData.scr = responseData.scr;
      this.gameData.bonus_cup = responseData.bonus_cup;

    }

    // send it back
    setTimeout(() => {

      this.onSignalBallDataReceived.dispatch(responseData);

    }, 200);

    return this.onSignalBallDataReceived;
  },

  fetchLeaderData_dumb() {

    const leaderData = [
      {id: 20, player_initials: 'Jake', score: 1640},
      {id: 21, player_initials: 'Skeewiz', score: 1490},
      {id: 1, player_initials: 'HDG', score: 1480},
      {id: 2, player_initials: '**mike892**', score: 1410},
      {id: 3, player_initials: 'Amy', score: 1400},
      {id: 4, player_initials: 'bbb', score: 1200},
      {id: 5, player_initials: 'ccc', score: 1050},
      {id: 6, player_initials: 'ddd', score: 940},
      {id: 7, player_initials: 'eee', score: 800},
      {id: 8, player_initials: 'fff', score: 200}

    ];

    // send it back
    setTimeout(() => {

      this.onSignalLeaderDataReceived.dispatch(leaderData);

    }, 200);

    return this.onSignalLeaderDataReceived;
  },

  fetchRankData_dumb(score) {

    // send it back
    setTimeout(() => {

      this.onSignalRankDataReceived.dispatch({rank: 3, totalGames: 5});

    }, 200);

    return this.onSignalRankDataReceived;

  },

  submitPlayerInitials_dumb(initials) {

    // send it back
    setTimeout(() => {

      this.onSignalInitialsSubmitted.dispatch({
        player_initials: initials
      });

    }, 200);

    return this.onSignalInitialsSubmitted;

  },

  // helpers
  generateBalls(numBalls) {

    // create an array of balls of random types
    // {color: 'brown', multiplier: 1}
    // 20% chance of RED 2x ball
    // 10% chance of BLUE 4x ball
    const newBalls = [];
    for (let i = 0; i < numBalls; i++)
    {
      // default
      const ball = {
        color: 'brown',
        multiplier: 1
      };

      // upgrade randomly
      const n = Math.random();
      if (n < 0.1)
      {
        ball.color = 'blue';
        ball.multiplier = 4;
      }
      else if (n < 0.3)
      {
        ball.color = 'red';
        ball.multiplier = 2;
      }

      newBalls.push(ball);
    }

    return newBalls;
  },

  generateGameToken(id) {

    return Date.now();
  },

  generateCupIDs() {
    // each cup ID needs to be a random 4 digit int
    // array elements correspond to cups:
    // 10, 20, 30, 40, 50, 100 (left), 100 (right)

    // no need to check for dupes, just setup a pool
    const pool = [2004,3269,7669,6113,8363,3031,4774,8366,5636,7367,3891,4254,3804,6971,9761,9610,8870,4167,7463,1111,3380,2669,8803,4369,4894,7636,2848,9401,6041,6297];

    return _.shuffle(pool).slice(0, 7);
  },

  cupIDScramble() {

    // return a random code to indicate how cup ids should be scrambled when checking the score
    return Math.floor(Math.random(10));
  },

  generateBonusCup(cup_ids) {

    // randomly pick a cup id or no cup (0)
    if (Math.random() < 0.4)
      return 0;

    return cup_ids[Math.floor(Math.random() * cup_ids.length)];
  },

  securityException(exceptionCode) {
    //console.log('SECURITY EXCEPTION: ', exceptionCode);
  }


};

// This module is dynamically "require'd", thus we need module.exports, not export default
module.exports = DummyTurnService;


// WEBPACK FOOTER //
// ./app/src/server/DummyTurnService.js